module.exports = __webpack_public_path__ + "static/media/lucina.d5c5016b.png";